import { Box, Typography } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { FC, useState } from "react";
import { EConfirmModalType, LoadingButton } from "src/shared/components";
import { useConfirmModal } from "src/shared/hooks";
import { Can } from "src/shared/lib/rback/Can";
import {
  useCalculateBonusesMutation,
  useSaveBonusesMutation,
} from "../../model/api/api";

interface ITableHeaderProps {
  handleSaveAll: () => void;
  isSavingAll: boolean;
  hasChanges: boolean;
  isBonusesCalculated: boolean;
}

export const TableHeader: FC<ITableHeaderProps> = ({
  handleSaveAll,
  isSavingAll,
  hasChanges,
  isBonusesCalculated,
}) => {
  const [confirmSaveBonusesMessage, setConfirmSaveBonusesMessage] =
    useState("");

  const [calculateBonuses, { isLoading: isLoadingCalculate }] =
    useCalculateBonusesMutation();
  const [saveBonuses, { isLoading: isLoadingSave }] = useSaveBonusesMutation();

  const { modal, showModal } = useConfirmModal({
    width: 768,
    onResolve: ({ result, closeModal }) => {
      if (result) {
        handleSaveBonuses();
      }
      closeModal();
    },
    title: "Подтвердите действие",
    children: <Typography>{confirmSaveBonusesMessage}</Typography>,
    confirmModalType: EConfirmModalType.STATUS,
    confirmBtnProps: { isLoading: isLoadingSave, children: "ДА, ПОДТВЕРДИТЬ" },
    cancelBtnProps: { children: "НЕТ, ВЕРНУТЬСЯ" },
  });

  const handleSaveBonuses = async () => {
    try {
      await saveBonuses().unwrap();
      enqueueSnackbar("Бонусы успешно сохранены", {
        variant: "success",
      });
    } catch (error) {
      enqueueSnackbar("Произошла ошибка", {
        variant: "error",
      });
    }
  };

  const handleSaveBonusesWithConfirm = () => {
    setConfirmSaveBonusesMessage(
      "Вы действительно хотите сохранить бонусы за этот период? После сохранения внесение корректировок в сумму бонусов по открутке уже недоступно",
    );
    showModal();
  };
  const handleCalculateBonuses = async () => {
    if (isBonusesCalculated) {
      enqueueSnackbar(
        "Действие не доступно. Бонусы за предыдущий период уже были рассчитаны.",
        {
          variant: "error",
        },
      );

      return;
    }

    try {
      await calculateBonuses().unwrap();
      enqueueSnackbar("Суммы бонусов успешно рассчитаны", {
        variant: "success",
      });
    } catch (error) {
      enqueueSnackbar("Произошла ошибка", {
        variant: "error",
      });
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        gap: 3,
      }}
    >
      <Typography variant="h6">
        Предварительный отчет по бонусам Партнеров
      </Typography>

      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          gap: 3,
          ml: "auto",
        }}
      >
        <Can perform="partners.draft-report.edit">
          <LoadingButton
            variant="contained"
            onClick={handleSaveAll}
            isLoading={isSavingAll}
            disabled={!hasChanges || isSavingAll}
          >
            Сохранить корректировки
          </LoadingButton>
          <LoadingButton
            disabled={isLoadingCalculate}
            onClick={() => handleCalculateBonuses()}
            isLoading={isLoadingCalculate}
            variant="outlined"
          >
            Рассчитать суммы бонусов
          </LoadingButton>
          <LoadingButton
            disabled={isLoadingSave}
            isLoading={isLoadingSave}
            onClick={() => handleSaveBonusesWithConfirm()}
            variant="contained"
            sx={{
              backgroundColor: "#FF7F27",
            }}
          >
            Сохранить бонусы
          </LoadingButton>
        </Can>
      </Box>
      {modal}
    </Box>
  );
};
